import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-auth-error',
    templateUrl: './auth-error.component.html',
    styleUrls: ['./auth-error.component.css'],
    standalone: false
})
export class AuthErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
